var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ef41a73a0868bfe75035c8c099c0b03d56660b18"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["price-assistant-app@onpreo"]={id:"ef41a73a0868bfe75035c8c099c0b03d56660b18"};
      